"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldPropsKeys = void 0;
exports.fieldPropsKeys = [
    'fieldName',
    'type',
    'value',
    'label',
    'errorMessage',
    'onChange',
    'disabled',
    'fieldSchema',
    'schema',
    'passProps'
];
//# sourceMappingURL=types.js.map